import { Helmet } from "react-helmet";
import { buildCanonicalUrl, SITE_NAME } from "./seoUtils";

/**
 * Meta tags مشترک برای صفحات عمومی (لیست، جزئیات، مقاله).
 */
export default function SeoMeta({
	title,
	description,
	path,
	imageUrl,
	type = "website",
	noindex = false,
	jsonLd,
}) {
	const fullTitle = title?.includes(SITE_NAME)
		? title
		: `${title} | ${SITE_NAME}`;
	const canonical = path ? buildCanonicalUrl(path) : null;
	const ogImage = imageUrl || null;

	return (
		<Helmet>
			<title>{fullTitle}</title>
			{description && <meta name="description" content={description} />}
			{canonical && <link rel="canonical" href={canonical} />}
			<meta property="og:locale" content="fa_IR" />
			<meta property="og:site_name" content={SITE_NAME} />
			<meta property="og:title" content={fullTitle} />
			{type && <meta property="og:type" content={type} />}
			{description && (
				<meta property="og:description" content={description} />
			)}
			{canonical && <meta property="og:url" content={canonical} />}
			{ogImage && <meta property="og:image" content={ogImage} />}
			<meta name="twitter:card" content={ogImage ? "summary_large_image" : "summary"} />
			<meta name="twitter:title" content={fullTitle} />
			{description && (
				<meta name="twitter:description" content={description} />
			)}
			{ogImage && <meta name="twitter:image" content={ogImage} />}
			{noindex && <meta name="robots" content="noindex,nofollow" />}
			{jsonLd && (
				<script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
			)}
		</Helmet>
	);
}
